export default (a, b) => new Set(Array.from(a).filter((x) => !b.has(x)));
//# sourceMappingURL=difference.mjs.map